import { createContext } from "react";
import type { GlobalStateContextType } from "@/GlobalStateProvider";

const GlobalStateContext = createContext<GlobalStateContextType | null>(null);
export default GlobalStateContext;
